import { defineMessages } from 'react-intl'

const baseId = 't.components.table.'

export default defineMessages({
  GoToPage: {
    id: baseId + 'GoToPage',
    defaultMessage: 'Vai alla pagina:',
  },
  Show: {
    id: baseId + 'Show',
    defaultMessage: 'mostra',
  },
  Page: {
    id: baseId + 'Page',
    defaultMessage: 'pagina:',
  },
  Of: {
    id: baseId + 'Of',
    defaultMessage: 'pagina:',
  },
  rowsFound: {
    id: baseId + 'rowsFound',
    defaultMessage: 'Result found: ',
  },
  ID: {
    id: baseId + 'ID',
    defaultMessage: 'ID',
  },
  IDENTITYSYSTEMID: {
    id: baseId + 'IDENTITYSYSTEMID',
    defaultMessage: 'IDENTITY',
  },
  IDENTITYAPPLICATIONID: {
    id: baseId + 'IDENTITYAPPLICATIONID',
    defaultMessage: 'ID',
  },
  VALUE: {
    id: baseId + 'VALUE',
    defaultMessage: 'VALUE',
  },
  TYPE: {
    id: baseId + 'TYPE',
    defaultMessage: 'TIPO',
  },
  ACTION: {
    id: baseId + 'ACTION',
    defaultMessage: 'ACTION',
  },
  STATUS: {
    id: baseId + 'STATUS',
    defaultMessage: 'STATO',
  },
  APPLICATION: {
    id: baseId + 'APPLICATION',
    defaultMessage: 'APPLICAZIONE',
  },
  ABILITATION: {
    id: baseId + 'ABILITATION',
    defaultMessage: 'ABILITAZIONI',
  },
  ENTITLEMENT: {
    id: baseId + 'ENTITLEMENT',
    defaultMessage: 'ENTITLEMENT',
  },
  EMERGENCYNAME: {
    id: baseId + 'EMERGENCYNAME',
    defaultMessage: 'EMERGENCY NAME',
  },
  CONFLICTENTITLEMENT: {
    id: baseId + 'CONFLICTENTITLEMENT',
    defaultMessage: 'CONFLICTENTITLEMENT',
  },
  CONFLICTENTITLEMENTNAME: {
    id: baseId + 'CONFLICTENTITLEMENTNAME',
    defaultMessage: 'CONFLICTENTITLEMENTNAME',
  },
  CONFLICT: {
    id: baseId + 'CONFLICT',
    defaultMessage: 'CONFLICT',
  },
  BENEFICIARY: {
    id: baseId + 'BENEFICIARY',
    defaultMessage: 'BENEFICIARIO',
  },
  CREATEDATE: {
    id: baseId + 'CREATEDATE',
    defaultMessage: 'DATA CREAZIONE',
  },
  DURATION: {
    id: baseId + 'DURATION',
    defaultMessage: 'DURATION (N° OF MONTHS)',
  },
  UPLOADDATE: {
    id: baseId + 'UPLOADDATE',
    defaultMessage: 'DATA DI CARICAMENTO',
  },
  APPOINTEE: {
    id: baseId + 'APPOINTEE',
    defaultMessage: 'INCARICATO',
  },
  BAOINFO: {
    id: baseId + 'BAOINFO',
    defaultMessage: 'BAO',
  },
  OBJECT: {
    id: baseId + 'OBJECT',
    defaultMessage: 'OBJECT',
  },
  ENTITLEMENTID: {
    id: baseId + 'ENTITLEMENTID',
    defaultMessage: 'ENTITLEMENT ID',
  },
  DESCRIPTION: {
    id: baseId + 'DESCRIPTION',
    defaultMessage: 'DESCRIPTION_',
  },
  ENTITLEMENTSNUMBER: {
    id: baseId + 'ENTITLEMENTSNUMBER',
    defaultMessage: 'NUBER_OF_ENTITLEMENTS',
  },
  USERSNUMBER: {
    id: baseId + 'USERSNUMBER',
    defaultMessage: 'NUMBER_OF_USERS',
  },
  OWNER: {
    id: baseId + 'OWNER',
    defaultMessage: 'OWNER_',
  },
  APPLICATIONNAME: {
    id: baseId + 'APPLICATIONNAME',
    defaultMessage: 'APPLICATION NAME',
  },
  APPLICATIONDESCRIPTION: {
    id: baseId + 'APPLICATIONDESCRIPTION',
    defaultMessage: 'APPLICATION DESC.',
  },
  ENTITLEMENTDESCRIPTION: {
    id: baseId + 'ENTITLEMENTDESCRIPTION',
    defaultMessage: 'ENTITLEMENT DESC.',
  },
  OUDESCRIPTION: {
    id: baseId + 'OUDESCRIPTION',
    defaultMessage: 'OU_DESCRIPTION',
  },
  MAXVALIDITYHOURS: {
    id: baseId + 'MAXVALIDITYHOURS',
    defaultMessage: 'MAX VALIDITY HOURS',
  },
  APPLICANT: {
    id: baseId + 'APPLICANT',
    defaultMessage: 'RICHIEDENTE',
  },
  CREATED_ON: {
    id: baseId + 'CREATED_ON',
    defaultMessage: 'CREATION DATE',
  },
  CREATEDON: {
    id: baseId + 'CREATED_ON',
    defaultMessage: 'CREATION DATE',
  },
  TICKET_ID: {
    id: baseId + 'TICKET_ID',
    defaultMessage: 'TICKET NUMBER',
  },
  TICKETNUMBER: {
    id: baseId + 'TICKETNUMBER',
    defaultMessage: 'TICKET NUMBER',
  },
  CTAUpdateListButton: {
    id: baseId + 'CTAUpdateListButton',
    defaultMessage: 'Add to Selected List',
  },
  CTABlack: {
    id: baseId + 'CTABlack',
    defaultMessage: 'Add to black List',
  },
  CTAWhite: {
    id: baseId + 'CTAWhite',
    defaultMessage: 'Add to white list',
  },
  CODE: {
    id: baseId + 'CODE',
    defaultMessage: 'USER ID',
  },
  COUNTERCODE: {
    id: baseId + 'COUNTERCODE',
    defaultMessage: 'COUNTER CODE',
  },
  ISDEFAULT: {
    id: baseId + 'ISDEFAULT',
    defaultMessage: 'DEFAULT',
  },
  ROLES: {
    id: baseId + 'ROLES',
    defaultMessage: 'ROLES',
  },
  NAME: {
    id: baseId + 'NAME',
    defaultMessage: 'NAME',
  },
  FULLNAME: {
    id: baseId + 'FULLNAME',
    defaultMessage: 'FULL NAME',
  },
  SURNAME: {
    id: baseId + 'SURNAME',
    defaultMessage: 'SURNAME',
  },
  COMPANY: {
    id: baseId + 'COMPANY',
    defaultMessage: 'COMPANY',
  },
  ORGANIZATIONAL_UNITS: {
    id: baseId + 'ORGANIZATIONAL_UNITS',
    defaultMessage: 'ORGANIZATIONAL UNITS',
  },
  ORGANIZATIONAL_UNIT: {
    id: baseId + 'ORGANIZATIONAL_UNIT',
    defaultMessage: 'ORGANIZATIONAL UNIT',
  },
  ORGANIZATIONAL_UNIT_CODE: {
    id: baseId + 'ORGANIZATIONAL_UNIT_CODE',
    defaultMessage: 'ORGANIZATIONAL UNIT CODE',
  },
  APPLICATION_DESCRIPTION: {
    id: baseId + 'APPLICATION_DESCRIPTION',
    defaultMessage: 'APPLICATION DESCRIPTION',
  },
  APPLICATION_ID: {
    id: baseId + 'APPLICATION_ID',
    defaultMessage: 'APPLICATION ID',
  },
  APPLICATION_NAME: {
    id: baseId + 'APPLICATION_NAME',
    defaultMessage: 'APPLICATION NAME',
  },
  ENTITLEMENT_DESCRIPTION: {
    id: baseId + 'ENTITLEMENT_DESCRIPTION',
    defaultMessage: 'ENTITLEMENT DESCRIPTION',
  },
  ENTITLEMENT_NAME: {
    id: baseId + 'ENTITLEMENT_NAME',
    defaultMessage: 'ENTITLEMENT NAME',
  },
  FORCECHANGEPWD: {
    id: baseId + 'FORCECHANGEPWD',
    defaultMessage: 'MANDATORY PASSWORD CHANGE',
  },
  LASTCHANGEPWD: {
    id: baseId + 'LASTCHANGEPWD',
    defaultMessage: 'LAST PASSWORD CHANGE',
  },
  NUMBERLOGINERROR: {
    id: baseId + 'NUMBERLOGINERROR',
    defaultMessage: 'N° LOGIN ERROR',
  },
  RESP_FULL_NAME: {
    id: baseId + 'RESP_FULL_NAME',
    defaultMessage: 'MANAGER',
  },
  MANAGER: {
    id: baseId + 'MANAGER',
    defaultMessage: 'MANAGER',
  },
  RESPONSIBLE: {
    id: baseId + 'MANAGER',
    defaultMessage: 'MANAGER',
  },
  ISOWNED: {
    id: baseId + 'ISOWNED',
    defaultMessage: 'IS OWNED',
  },
  IDENTITYSYSTEM: {
    id: baseId + 'IDENTITYSYSTEM',
    defaultMessage: 'IDENTITY SYSTEM',
  },
  ENTITLEMENTNAME: {
    id: baseId + 'ENTITLEMENTNAME',
    defaultMessage: 'ENTITLEMENT NAME',
  },
  ENRICHMENT: {
    id: baseId + 'ENRICHMENT',
    defaultMessage: 'TAKE CHARGE',
  },
  APPROVALBAO: {
    id: baseId + 'APPROVALBAO',
    defaultMessage: 'BAO',
  },
  SIZE: {
    id: baseId + 'SIZE',
    defaultMessage: 'SIZE',
  },
  CONFIGURATION: {
    id: baseId + 'CONFIGURATION',
    defaultMessage: 'CONFIGURATION',
  },
  NETSID: {
    id: baseId + 'NETSID',
    defaultMessage: 'NETS ID',
  },
  NETSORGUNITID: {
    id: baseId + 'NETSORGUNITID',
    defaultMessage: 'NETS ORGANIZATIONAL UNIT',
  },
  NETSPERSONID: {
    id: baseId + 'NETSPERSONID',
    defaultMessage: 'NETS PERSON ID',
  },
  ATTRIBUTEID: {
    id: baseId + 'ATTRIBUTEID',
    defaultMessage: 'ATTRIBUTE ID',
  },
  ATTRIBUTENAME: {
    id: baseId + 'ATTRIBUTENAME',
    defaultMessage: 'ATTRIBUTE NAME',
  },
  ATTRIBUTEVALUE: {
    id: baseId + 'ATTRIBUTEVALUE',
    defaultMessage: 'ATTRIBUTE VALUE',
  },
  VISIBILITYCONE: {
    id: baseId + 'VISIBILITYCONE',
    defaultMessage: 'VISIBILITY CONE',
  },
  //PASSWORD ADMIN MANAGEMENT
  PROPAGATIONID: {
    id: baseId + 'PROPAGATIONID',
    defaultMessage: 'PROPAGATIONID',
  },
  SOURCETARGETID: {
    id: baseId + 'SOURCETARGETID',
    defaultMessage: 'SOURCETARGETID',
  },
  SOURCEIDENTITYSYSTEMID: {
    id: baseId + 'SOURCEIDENTITYSYSTEMID',
    defaultMessage: 'SOURCEIDENTITYSYSTEMID',
  },
  DESTTARGETID: {
    id: baseId + 'DESTTARGETID',
    defaultMessage: 'DESTTARGETID',
  },
  DESTIDENTITYSYSTEMID: {
    id: baseId + 'DESTIDENTITYSYSTEMID',
    defaultMessage: 'DESTIDENTITYSYSTEMID',
  },
  //SERVICE REQUEST ADMIN
  IDTICKETTEMPLATE: {
    id: baseId + 'IDTICKETTEMPLATE',
    defaultMessage: 'IDTICKETTEMPLATE',
  },
  IDSERVICEREQUEST: {
    id: baseId + 'IDSERVICEREQUEST',
    defaultMessage: 'IDSERVICEREQUEST',
  },
  TICKETSYSTEMID: {
    id: baseId + 'TICKETSYSTEMID',
    defaultMessage: 'TICKETSYSTEMID',
  },
  IDTEMPLATE: {
    id: baseId + 'IDTEMPLATE',
    defaultMessage: 'IDTEMPLATE',
  },
  FIELDNAME: {
    id: baseId + 'FIELDNAME',
    defaultMessage: 'FIELDNAME',
  },
  FIELDVALUE: {
    id: baseId + 'FIELDVALUE',
    defaultMessage: 'FIELDVALUE',
  },
  SERVICEREQUESTID: {
    id: baseId + 'SERVICEREQUESTID',
    defaultMessage: 'SERVICEREQUESTID',
  },
  SERVICEREQUESTNAME: {
    id: baseId + 'SERVICEREQUESTNAME',
    defaultMessage: 'SERVICEREQUESTNAME',
  },
  DISPLAYORDER: {
    id: baseId + 'DISPLAYORDER',
    defaultMessage: 'DISPLAYORDER',
  },
  IDFIELD: {
    id: baseId + 'IDFIELD',
    defaultMessage: 'IDFIELD',
  },
  FIELDTYPE: {
    id: baseId + 'FIELDTYPE',
    defaultMessage: 'FIELDTYPE',
  },
  IDEXTERNAL: {
    id: baseId + 'IDEXTERNAL',
    defaultMessage: 'IDEXTERNAL',
  },
  FIELDID: {
    id: baseId + 'FIELDID',
    defaultMessage: 'FIELDID',
  },
  TICODE: {
    id: baseId + 'TICODE',
    defaultMessage: 'TI CODE',
  },
  OLDOUCODE: {
    id: baseId + 'OLDOUCODE',
    defaultMessage: 'OLD OU CODE',
  },
  OLDMANAGER: {
    id: baseId + 'OLDMANAGER',
    defaultMessage: 'OLD MANAGER',
  },
  NEWOUCODE: {
    id: baseId + 'NEWOUCODE',
    defaultMessage: 'NEW OU CODE',
  },
  //REPORT ADMIN - PARAMETER
  PARAMETER: {
    id: baseId + 'PARAMETER',
    defaultMessage: 'PARAMETER',
  },
  PROPERTY: {
    id: baseId + 'PROPERTY',
    defaultMessage: 'PROPERTY',
  },
  SUPERVISORFULLNAME: {
    id: baseId + 'SUPERVISORFULLNAME',
    defaultMessage: 'SUPERVISOR',
  },
  // IDENTITY
  IGI: {
    id: baseId + 'IGI',
    defaultMessage: 'IGI',
  },
  // OPERATION TYPE
  ADD_TEMPORARY_ENTITLEMENT: {
    id: baseId + 'ADD_TEMPORARY_ENTITLEMENT',
    defaultMessage: 'ADD TEMPORARY ENTITLEMENT',
  },
  ADD_ENTITLEMENT_TO_USER: {
    id: baseId + 'ADD_ENTITLEMENT_TO_USER',
    defaultMessage: 'ADD ENTITLEMENT',
  },
  REMOVE_ENTITLEMENT_FROM_USER: {
    id: baseId + 'REMOVE_ENTITLEMENT_FROM_USER',
    defaultMessage: 'REMOVE ENTITLEMENT',
  },
  EDIT_ENTITLEMENT_TO_USER: {
    id: baseId + 'EDIT_ENTITLEMENT_TO_USER',
    defaultMessage: 'EDIT ENTITLEMENT',
  },
  ADD_ENTITLEMENT_TO_CATALOG: {
    id: baseId + 'ADD_ENTITLEMENT_TO_CATALOG',
    defaultMessage: 'ADD ENTITLEMENT TO CATALOG',
  },
  REMOVE_ENTITLEMENT_FROM_CATALOG: {
    id: baseId + 'REMOVE_ENTITLEMENT_FROM_CATALOG',
    defaultMessage: 'REMOVE ENTITLEMENT FROM CATALOG',
  },
  ADD_EMERGENCY_USER_RACF: {
    id: baseId + 'ADD_EMERGENCY_USER_RACF',
    defaultMessage: 'ADD EMERGENCY ENTITLEMENT RACF',
  },
  ADD_BUSINESS_ROLE_TO_USER: {
    id: baseId + 'ADD_BUSINESS_ROLE_TO_USER',
    defaultMessage: 'ADD BUSINESS ROLE TO USER',
  },
  REMOVE_BUSINESS_ROLE_TO_USER: {
    id: baseId + 'REMOVE_BUSINESS_ROLE_TO_USER',
    defaultMessage: 'REMOVE BUSINESS ROLE TO USER',
  },
  RESET_PASSWORD: {
    id: baseId + 'RESET_PASSWORD',
    defaultMessage: 'RESET PASSWORD',
  },
  CHANGE_PASSWORD: {
    id: baseId + 'CHANGE_PASSWORD',
    defaultMessage: 'CHANGE PASSWORD',
  },
  DELETE_BUSINESS_ROLE: {
    id: baseId + 'DELETE_BUSINESS_ROLE',
    defaultMessage: 'DELETE_BUSINESS_ROLE',
  },
  CREATE_BUSINESS_ROLE: {
    id: baseId + 'CREATE_BUSINESS_ROLE',
    defaultMessage: 'CREATE_BUSINESS_ROLE',
  },
  UPDATE_BUSINESS_ROLE: {
    id: baseId + 'UPDATE_BUSINESS_ROLE',
    defaultMessage: 'UPDATE_BUSINESS_ROLE',
  },
  SERVICE_REQUEST: {
    id: baseId + 'SERVICE_REQUEST',
    defaultMessage: 'SERVICE_REQUEST',
  },
  REPORT_GENERETING: {
    id: baseId + 'REPORT_GENERETING',
    defaultMessage: 'REPORT GENERETING',
  },
  ADD_ENTITLEMENT_TO_TECHNICAL_USER: {
    id: baseId + 'ADD_ENTITLEMENT_TO_TECHNICAL_USER',
    defaultMessage: 'ADD ENTITLEMENT TO TECHNICAL USER',
  },
  REMOVE_ENTITLEMENT_FROM_TECHNICAL_USER: {
    id: baseId + 'REMOVE_ENTITLEMENT_FROM_TECHNICAL_USER',
    defaultMessage: 'REMOVE ENTITLEMENT FROM TECHNICAL USER',
  },
  DELETE_TECHNICAL_USER: {
    id: baseId + 'DELETE_TECHNICAL_USER',
    defaultMessage: 'DELETE TECHNICAL USER',
  },
  TECHNICAL_USER_RESET_PWD: {
    id: baseId + 'TECHNICAL_USER_RESET_PWD',
    defaultMessage: 'TECHNICAL USER RESET PWD',
  },
  TECHNICAL_USER_CHANGE_PWD: {
    id: baseId + 'TECHNICAL_USER_CHANGE_PWD',
    defaultMessage: 'TECHNICAL USER CHANGE PWD',
  },
  CREATE_TECH_USER: {
      id: baseId + 'CREATE_TECH_USER',
      defaultMessage: 'CREATE TECHNICAL USER',
  },
  ACCOUNT: {
    id: baseId + 'ACCOUNT',
    defaultMessage: 'ACCOUNT',
  },
  BUSINESS_ROLE: {
    id: baseId + 'BUSINESS_ROLE',
    defaultMessage: 'BUSINESS ROLE',
  },
  OU: {
    id: baseId + 'OU',
    defaultMessage: 'CATALOG',
  },
  ORGANIZATIONALUNIT: {
    id: baseId + 'ORGANIZATIONALUNIT',
    defaultMessage: 'CATALOG',
  },
  USER: {
    id: baseId + 'USER',
    defaultMessage: 'USER',
  },
  REVISOR: {
    id: baseId + 'REVISOR',
    defaultMessage: 'REVISOR',
  },
  INVOLVEDINSOD: {
    id: baseId + 'INVOLVEDINSOD',
    defaultMessage: 'INVOLVED IN SOD',
  },
  EMAIL: {
    id: baseId + 'EMAIL',
    defaultMessage: 'EMAIL',
  },
  CREATE_ON: {
    id: baseId + 'CREATE_ON',
    defaultMessage: 'CREATO IL',
  },
  ACCOUNTID: {
    id: baseId + 'ACCOUNTID',
    defaultMessage: 'ID ACCOUNT',
  },
  INPUTENTITLEMENTNAME: {
    id: baseId + 'INPUTENTITLEMENTNAME',
    defaultMessage: 'ENTITLEMENT',
  },
  INPUTAPPLICATIONNAME: {
    id: baseId + 'INPUTAPPLICATIONNAME',
    defaultMessage: 'APPLICATION',
  },
  CHECKENTITLEMENTNAME: {
    id: baseId + 'CHECKENTITLEMENTNAME',
    defaultMessage: 'CONFLICTENTITLEMENT',
  },
  CHECKAPPLICATIONNAME: {
    id: baseId + 'CHECKAPPLICATIONNAME',
    defaultMessage: 'CONFLICT APPLICATION',
  },
  CONFLICTCODE: {
    id: baseId + 'CONFLICTCODE',
    defaultMessage: 'CONFLICT',
  },

  // TASK ACTION TYPE
  AGGREGATED: {
    id: baseId + 'AGGREGATED',
    defaultMessage: 'AGGREGATED',
  },
  PERMISSION_ADD: {
    id: baseId + 'PERMISSION_ADD',
    defaultMessage: 'ADD PERMISSION',
  },
  PERMISSION_REMOVE: {
    id: baseId + 'PERMISSION_REMOVE',
    defaultMessage: 'REMOVE PERMISSION',
  },
  ACCOUNT_DISABLE: {
    id: baseId + 'ACCOUNT_DISABLE',
    defaultMessage: 'ACCOUNT DISABLE',
  },
  ACCOUNT_ENABLE: {
    id: baseId + 'ACCOUNT_ENABLE',
    defaultMessage: 'ACCOUNT ENABLE',
  },
  ACCOUNT_CREATE: {
    id: baseId + 'ACCOUNT_CREATE',
    defaultMessage: 'CREATE ACCOUNT',
  },
  ACCOUNT_REMOVE: {
    id: baseId + 'ACCOUNT_REMOVE',
    defaultMessage: 'REMOVE ACCOUNT',
  },
  ACCOUNT_MODIFY: {
    id: baseId + 'ACCOUNT_MODIFY',
    defaultMessage: 'MODIFY ACCOUNT',
  },
  ACCOUNT_PWDCHANGE: {
    id: baseId + 'ACCOUNT_PWDCHANGE',
    defaultMessage: 'ACCOUNT PASSWORD CHANGE',
  },
  DELEGATED: {
    id: baseId + 'DELEGATED',
    defaultMessage: 'DELEGATED',
  },
  ROLE: {
    id: baseId + 'ROLE',
    defaultMessage: 'ROLE',
  },
  BEGIN_DATE: {
    id: baseId + 'BEGIN_DATE',
    defaultMessage: 'BEGIN DATE',
  },
  END_DATE: {
    id: baseId + 'END_DATE',
    defaultMessage: 'END DATE',
  },
  ENDDATE: {
    id: baseId + 'ENDDATE',
    defaultMessage: 'END DATE',
  },
  REQUESTOR: {
    id: baseId + 'REQUESTOR',
    defaultMessage: 'REQUESTOR',
  },
  TRUE: {
    id: baseId + 'TRUE',
    defaultMessage: 'TRUE',
  },
  FALSE: {
    id: baseId + 'FALSE',
    defaultMessage: 'FALSE',
  },
  PROGRESS: {
    id: baseId + 'PROGRESS',
    defaultMessage: 'PROGRESS',
  },
  violationOfVisibilityMessage: {
    id: baseId + 'violationOfVisibilityMessage',
    defaultMessage: 'Entitlement in violation of visibility',
  },
  temporaryMessage: {
    id: baseId + 'temporaryMessage',
    defaultMessage: 'Temporary Entitlement',
  },
  // EXTERNAL PORTAL
  USERCODE: {
    id: baseId + 'USERCODE',
    defaultMessage: 'USER CODE',
  },
  USERTYPE: {
    id: baseId + 'USERTYPE',
    defaultMessage: 'USER TYPE',
  },
  TITYPE: {
    id: baseId + 'TITYPE',
    defaultMessage: 'USER TECHNICAL TYPE',
  },
  STATUSDESC: {
    id: baseId + 'STATUSDESC',
    defaultMessage: 'STATUS',
  },
  TERMINATIONDATE: {
    id: baseId + 'TERMINATIONDATE',
    defaultMessage: 'TERMINATION DATE',
  },
  REFERRAL: {
    id: baseId + 'REFERRAL',
    defaultMessage: 'REFERRAL',
  },
  RELATIONSHIPENDDATE: {
    id: baseId + 'RELATIONSHIPENDDATE',
    defaultMessage: 'RELATIONSHIP END DATE',
  },
  EXTERNALCOMPANYDESC: {
    id: baseId + 'EXTERNALCOMPANYDESC',
    defaultMessage: 'EXTERNAL COMPANY DESC',
  },
  COMPANYEMAIL: {
    id: baseId + 'COMPANYEMAIL',
    defaultMessage: 'COMPANY EMAIL',
  },
  // EXTERNAL PORTAL MGMT CONSOLE ADMIN
  FIELDCODE: {
    id: baseId + 'FIELDCODE',
    defaultMessage: 'FIELD CODE',
  },
  FIELDAREA: {
    id: baseId + 'FIELDAREA',
    defaultMessage: 'FIELD AREA',
  },
  FIELDORDER: {
    id: baseId + 'FIELDORDER',
    defaultMessage: 'FIELD ORDER',
  },
  COUNTERID: {
    id: baseId + 'COUNTERID',
    defaultMessage: 'COUNTER ID',
  },
  COUNTERLASTID: {
    id: baseId + 'COUNTERLASTID',
    defaultMessage: 'COUNTER LAST ID',
  },
  COUNTERLENGTH: {
    id: baseId + 'COUNTERLENGTH',
    defaultMessage: 'COUNTER LENGTH',
  },
  COUNTERPREFIX: {
    id: baseId + 'COUNTERPREFIX',
    defaultMessage: 'COUNTER PREFIX',
  },
  OUCODE: {
    id: baseId + 'OUCODE',
    defaultMessage: 'OU CODE',
  },
  OUTYPE: {
    id: baseId + 'OUTYPE',
    defaultMessage: 'OU TYPE',
  },
  OUIDCOUNTER: {
    id: baseId + 'OUIDCOUNTER',
    defaultMessage: 'OU ID COUNTER',
  },
  // CATALOG MGMT CONSOLE ADMIN
  OWNERCODE: {
    id: baseId + 'OWNERCODE',
    defaultMessage: 'OWNER CODE',
  },
  // TEMPLATE MAIL MGMT CONSOLE ADMIN
  SUBJECT: {
    id: baseId + 'SUBJECT',
    defaultMessage: 'SUBJECT',
  },
  MAX_RETRY: {
    id: baseId + 'MAX_RETRY',
    defaultMessage: 'MAX RETRY',
  },
  // WORKFLOW MGMT CONSOLE ADMIN
  MIN_APPROVAL: {
    id: baseId + 'MIN_APPROVAL',
    defaultMessage: 'MIN APPROVAL',
  },
  STEP_ORDER: {
    id: baseId + 'STEP_ORDER',
    defaultMessage: 'STEP ORDER',
  },
  WORKFLOW_ID: {
    id: baseId + 'WORKFLOW_ID',
    defaultMessage: 'WORKFLOW ID',
  },
  STEP_CODE: {
    id: baseId + 'STEP_CODE',
    defaultMessage: 'STEP CODE',
  },
  APPROVER: {
    id: baseId + 'APPROVER',
    defaultMessage: 'APPROVER',
  },
  IS_ROLE: {
    id: baseId + 'IS_ROLE',
    defaultMessage: 'IS ROLE',
  },
  STEP_DESCRIPTION: {
    id: baseId + 'STEP_DESCRIPTION',
    defaultMessage: 'STEP DESCRIPTION',
  },
  STEP_ID: {
    id: baseId + 'STEP_ID',
    defaultMessage: 'STEP ID',
  },
  IS_REJECT_ATOMIC: {
    id: baseId + 'IS_REJECT_ATOMIC',
    defaultMessage: 'IS REJECT ATOMIC',
  },
  // CAMPAIGN OPERATION
  KEEP: {
    id: baseId + 'KEEP',
    defaultMessage: 'KEEP',
  },
  REVOKE: {
    id: baseId + 'REVOKE',
    defaultMessage: 'REVOKE',
  },
  VALIDATE: {
    id: baseId + 'VALIDATE',
    defaultMessage: 'VALIDATE',
  },
  USERCODESOCIETYVALIDATION: {
    id: baseId + 'USERCODESOCIETYVALIDATION',
    defaultMessage: 'USER CODE',
  },
  //NOTIFICATION MGMT
  TITLE: {
    id: baseId + 'TITLE',
    defaultMessage: 'TITLE',
  },
  MESSAGE: {
    id: baseId + 'MESSAGE',
    defaultMessage: 'MESSAGE',
  },
  STARTDATE: {
    id: baseId + 'STARTDATE',
    defaultMessage: 'STARTDATE',
  },
  ROLELIST: {
    id: baseId + 'ROLELIST',
    defaultMessage: 'ROLELIST',
  },
  // TOOLTIPS MESSAGES
  UNLOCK: {
    id: baseId + 'unlockPwdMessage',
    defaultMessage: 'Unlock account',
  },
  RESET: {
    id: baseId + 'resetPwdMessage',
    defaultMessage: 'Reset password',
  },
  CHANGE: {
    id: baseId + 'changePwdMessage',
    defaultMessage: 'Change password',
  },
  BLOCK: {
    id: baseId + 'blockAccountMessage',
    defaultMessage: 'Block account',
  },
  //AUDIT MANAGEMENT
  AUDITDATE: {
    id: baseId + 'AUDITDATE',
    defaultMessage: 'AUDIT DATE',
  },
  OBJECTDESC: {
    id: baseId + 'OBJECTDESC',
    defaultMessage: 'OBJECT DESCRIPTION',
  },
  OBJECTID: {
    id: baseId + 'OBJECTID',
    defaultMessage: 'OBJECT ID',
  },
  OBJECTIDENTITYSYSTEMID: {
    id: baseId + 'OBJECTIDENTITYSYSTEMID',
    defaultMessage: 'OBJECT IDENTITY SYSTEM ID',
  },
  OBJECTTYPE: {
    id: baseId + 'OBJECTTYPE',
    defaultMessage: 'OBJECT TYPE',
  },
  AUDITOPERATION: {
    id: baseId + 'AUDITOPERATION',
    defaultMessage: 'OPERATION',
  },
  SMSOPERATION: {
    id: baseId + 'SMSOPERATION',
    defaultMessage: 'OPERATION',
  },
  OPERATIONBY: {
    id: baseId + 'OPERATIONBY',
    defaultMessage: 'OPERATION BY',
  },
  SUBJECTID: {
    id: baseId + 'SUBJECTID',
    defaultMessage: 'SUBJECT ID',
  },
  SUBJECTDESC: {
    id: baseId + 'SUBJECTDESC',
    defaultMessage: 'SUBJECT DESCRIPTION',
  },
  SUBJECTIDENTITYSYSTEMID: {
    id: baseId + 'SUBJECTIDENTITYSYSTEMID',
    defaultMessage: 'SUBJECT IDENTITY SYSTEM ID',
  },
  SUBJECTTYPE: {
    id: baseId + 'SUBJECTTYPE',
    defaultMessage: 'SUBJECT TYPE',
  },
  YESVALUE: {
    id: baseId + 'YESVALUE',
    defaultMessage: 'YES',
  },
  NOVALUE: {
    id: baseId + 'NOVALUE',
    defaultMessage: 'NO',
  },
  VALUESYSTEMPROPERTYADMINAPPLICATIONSABILITATIONSMGMT: {
    id: baseId + 'VALUESYSTEMPROPERTYADMINAPPLICATIONSABILITATIONSMGMT',
    defaultMessage: 'VALUE',
  },
  AVAILABLE: {
    id: baseId + 'AVAILABLE',
    defaultMessage: 'AVAILABLE',
  },
  MAXDURATION: {
    id: baseId + 'MAXDURATION',
    defaultMessage: 'MAXDURATION',
  },
  MAXHOURS: {
    id: baseId + 'MAXHOURS',
    defaultMessage: 'MAXHOURS',
  },
  FIELD: {
    id: baseId + 'FIELD',
    defaultMessage: 'FIELD',
  },
  ACCOUNTCODE: {
    id: baseId + 'ACCOUNTCODE',
    defaultMessage: 'ACCOUNT',
  },
  SHOW_ON_FRONTEND_CONSOLE_ADMIN_APPLICATIONS_ABILITATIONS_MGMT: {
    id:
      baseId + 'SHOW_ON_FRONTEND_CONSOLE_ADMIN_APPLICATIONS_ABILITATIONS_MGMT',
    defaultMessage: 'SHOW ON FRONTEND',
  },
  TECHNICAL_USER: {
    id: baseId + 'TECHNICAL_USER',
    defaultMessage: 'TECHNICAL USER',
  },
  ROBOTO_USER: {
    id: baseId + 'ROBOTO_USER',
    defaultMessage: 'ROBOTO USER',
  },
  SERVICE: {
    id: baseId + 'Service',
    defaultMessage: 'SERVICE USER',
  },
  TECHNICAL_IDENTITY: {
    id: baseId + 'TECHNICAL_IDENTITY',
    defaultMessage: 'TECHNICAL IDENTITY',
  },
  SOD: {
    id: baseId + 'SOD',
    defaultMessage: 'SOD',
  },
})
